import React, { useEffect } from "react";
import { BundleInterface } from "src/store/callrecorder/bundlesSlice";

import { Button, Form, Input, Switch } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: BundleInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='name' label="Name">
        <Input disabled={!!params?.id} />
      </Form.Item>

      <FileDropzone name='voip_cert' label='Voip Cert' preview={params?.voip_cert_url} />

      <Form.Item name='voip_cert_secret' label="Voip Password">
        <Input />
      </Form.Item>

      <Form.Item name='shared_secret' label="Shared Secret">
        <Input />
      </Form.Item>

      <Form.Item name='twilio_service_sid' label="Twilio Service SID">
        <Input />
      </Form.Item>

      <Form.Item label="Environment" name='prod_env' valuePropName='checked'>
        <Switch
          checkedChildren='production'
          unCheckedChildren='development'
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
